/** Fases de jobs IA (backend + labels UI). */
export const IA_JOB_PHASES = [
  { key: 'recebidos', label: 'Recebidos' },
  { key: 'analisando', label: 'Analisando' },
  { key: 'processando', label: 'Processando' },
  { key: 'finalizando', label: 'Finalizando' },
  { key: 'aguarde', label: 'Aguarde' },
  { key: 'ok', label: 'Ok' },
];

export const SIMULATED_PENDING_PHASE_KEYS = ['recebidos', 'analisando', 'processando', 'finalizando'];

export function phaseLabel(phaseKey) {
  const p = IA_JOB_PHASES.find((x) => x.key === phaseKey);
  return p?.label || 'Processando';
}
